<div class="container-fluid">
    <div class="row header-oferta">
        <div class="col-md-12">
            <div class="row">
                <div class="col-1">
                </div>
                <div class="col-1">
                    <ngx-avatar size="40" src="assets/images/general/avatar.png"></ngx-avatar>
                </div>
                <div class="col-10">
                    <h4>{{clienteserviceParam.datosCliente.cliente.nombreCompleto|accentMark: false }}</h4>
                    <p>Código Cliente: {{clienteserviceParam.datosCliente.cliente.codigoClienteBantrab}}</p>
                    <!--
                    <p *ngIf="!clienteserviceParam.datosCliente.needCoDebtor">Score predictivo {{this.clienteserviceParam.datosPrecalificacion.segmento!='PV'?'interno':''}} deudor: {{ clienteserviceParam.debtorScore|number:'1.0-0' }}</p>
                    <p *ngIf="clienteserviceParam.coDebtorScore !== '0' && clienteserviceParam.coDebtorScore !== '0.0' && clienteserviceParam.flowType === 'CODEBTOR'">Score predictivo {{this.clienteserviceParam.datosPrecalificacion.segmento!='PV'?'interno':''}} codeudor: {{ clienteserviceParam.coDebtorScore|number:'1.0-0' }}</p>
                    -->
                </div>
            </div>
        </div>
        <h2 style="margin-left: 20px;">Seleccione una tarjeta</h2>
    </div>
    <div>
        <hr
            style="text-align: center; background-image: linear-gradient(90deg, #00abb6 15%, #05718f 56%) !important; color: #fff;height: 4px;box-shadow: 0px 5px 12px 0px rgb(0 0 0 / 44%);">
        <div style="overflow-y:scroll;height:350px !important;padding-bottom: 200px;">
            <div *ngFor="let item of ofertasComerciales; let i = index">
                <div class="product_{{item.nombreCategoria}}">
                    <div class="row product_container">
                        <div class="col-md-1 p-0">
                            <img src="../../../assets/icons/tarjetadebito.png" height="45px" >
                        </div>
                        <div class="col-md-3 p-0">
                            <h1 >Categoría</h1>
                            <h2 >{{item.nombreCategoria}}</h2>
                        </div>
                        <div class="col-md-2 p-0">
                            <ng-container *ngIf="!clienteserviceParam.rolABFlag">
                                <h3>Minimo</h3>
                                <h2>Q {{item.limiteInferior | number:'1.2-2'}}</h2>
                            </ng-container>
                        </div>
                        <div class="col-md-2 p-0">
                            <ng-container *ngIf="!clienteserviceParam.rolABFlag">
                                <h3>Maximo</h3>
                                <h2>Q {{item.limiteSuperior | number:'1.2-2'}}</h2>
                            </ng-container>
                        </div>
                        <div class="col-md-2 p-0">
                            <ng-container *ngIf="!clienteserviceParam.rolABFlag">
                                <h3>Monto</h3>
                                <h2>Q {{item.montoAutorizado | number:'1.2-2'}}</h2>
                            </ng-container>
                        </div>
                        <div class="col-md-2 p-0">
                            <div class="custom-control custom-switch">
                                <input *ngIf="ofertaseleccionada!=i" type="checkbox" (change)="selectOferta(i)"
                                    class="custom-control-input" id="{{i}}">
                                <input *ngIf="ofertaseleccionada==i" type="checkbox" (change)="selectOferta(i)"
                                    class="custom-control-input" id="{{i}}" checked disabled>
                                <label class="custom-control-label" for="{{i}}"></label>
                            </div>
                        </div>
                        <div class="col-md-6 pt-5" *ngIf="!clienteserviceParam.rolABFlag">
                            <span class="rounded-label vertical-center">{{item.nombreComercial}}</span>
                        </div>
                        <div class="col-md-2 p-0">
                            <ng-container *ngIf="!clienteserviceParam.rolABFlag">
                                <h3>Cuota</h3>
                                <h2>Q {{item.cuotaNuevoCredito | number:'1.2-2'}}</h2>                                
                            </ng-container>
                        </div>
                        <div class="col-md-2 p-0">
                            <ng-container *ngIf="!clienteserviceParam.rolABFlag">
                                <h3>RCI Final</h3>
                                <h2>{{ item.rciInternoFinalDeudor|number:'1.2-2' }}%</h2>
                            </ng-container>
                        </div>
                        <ng-container *ngIf="!clienteserviceParam.rolABFlag && (item.tipo=='TC_REMESA_TXT'||item.tipo=='TC_PV_TXT')">
                            <hr class="hline">
                            <div class="col-md-1 p-0">
                            </div>
                            <div  class="col-md-3 p-0">
                                <h1>Tarjeta Externa</h1>
                                <h2>Entidad {{item.codigoEntidadTCExterna}}</h2>
                            </div>
                            <div class="col-md-2 p-0">
                                <h3>Capital</h3>
                                <h2>Q {{item.limiteTCExterna | number:'1.2-2'}}</h2>
                            </div>
                            <div class="col-md-2 p-0">
                                <h3>Saldo</h3>
                                <h2>Q {{item.saldoTcExterna | number:'1.2-2'}}</h2>
                            </div>
                            <div class="col-md-2 p-0">
                                <h3>Fecha</h3>
                                <h2>{{item.fechaConceTCExterna}}</h2>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div style="text-align: left;" *ngIf="clienteserviceParam.tipoPrecalificacion !== 'tarjeta_credito'">
                    <button class="btn round-button-back" (click)="goBack()">Regresar</button>
                </div>
            </div>
            <div class="col-md-6">
                <div style="text-align: right;">
                    <button class="btn round-button" (click)="goToSeleccion()">Continuar</button>
                </div>
            </div>
        </div>
    </div>

</div>